// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"dfe35665","410":"9162d55c","443":"5da19b40","453":"b6fdcd54","840":"13af308d"}[chunkId] + ".chunk.js";
};